import React, {useState, useEffect, useRef} from "react";
import {Link,useParams,useLocation} from 'react-router-dom';
import moment from 'moment';
import { postData,getData } from '../../config/api-connect';
import {  
        Table, Select, DatePicker, Spin, Input, Breadcrumb,
        Progress, Empty, Typography, Skeleton,Menu, Col,
        Row, Statistic ,Card,Button, InputNumber, 
        message, Modal, Form
      } from 'antd';
import { ArrowRightOutlined, HomeOutlined, BankFilled, EditOutlined ,FilterFilled, SearchOutlined, CheckCircleOutlined} from '@ant-design/icons';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'
import {toProperCase} from '../../utils/stringUtil.js'
import {getDropdownFilter,getSearchFilter} from '../../utils/filterHelper.jsx'

const { Option } = Select;

const UnverifiedCollections = () => {
	var today = new Date();
	const { venue_name } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [form] = Form.useForm();
  let venue_id = queryParams.get('venue_id');
  var local_selectedVenueName = venue_name
  var local_month = JSON.parse(localStorage.getItem('month'));
  var local_year = JSON.parse(localStorage.getItem('year'));

  var local_city = JSON.parse(localStorage.getItem('cityId'))

  let local_selectedVenueId = venue_id;
  if(!venue_id) {
    local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  }

  const [loading, setLoading] = useState(true)
  const [isSaving,setIsSaving] = useState(false)
  const [month, setMonth] = useState(local_month)
  const [year, setYear] = useState(local_year)
  const [cityId, setCityId] = useState(local_city)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [venuelist, setVenuelist] = useState([])
  const [collectionData,setCollectionData] = useState([])
  const [venueName,setVenueName] = useState(local_selectedVenueName)
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState([])
  const [selectedCollectionID,setSelectedCollectionID] = useState(null)
  const [selectedTransactionID,setSelectedTransactionID] = useState('')

  const [phonePeLoader, setPhonePeLoader] = useState(false)
  const [phonePeEntries, setPhonePeEntries] = useState([])
  const [selectedPhonePeID, setSelectedPhonePeID] = useState('')

  const inputRef = useRef(null);

  useEffect(() => {
    if (isModalVisible) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100); // delay because of animation
    }
  }, [isModalVisible]);

  useEffect(() => {
  	localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    if(cityId !== ''){
      setLoading(true)
      getUnverifiedCollections()
    }
  }, [month,year]); 

  const getUnverifiedCollections = () => {
  	setLoading(true)
    getData(`/business/get_unverified_collections/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
       setCollectionData(response.results);
    })
    .catch(error => {
      console.log(error.message);
    })
    .finally(()=>{
      setLoading(false)
    })
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };  

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const handleFormSubmit = async () => {
    setIsSaving(true);
    try {
      const transactionID = selectedTransactionID;
      
      const response = await postData('/finance/update_transaction_id/', {
        'collection_id': selectedCollectionID,
        'transaction_id': transactionID
      });
      alert(response.message)
      setIsModalVisible(false);
      getUnverifiedCollections();
    } catch (errorInfo) {
      console.log('Validation Failed:', errorInfo);
    } finally {
      setIsSaving(false);
    }
  };

  const openActionModal = (collectionID,transactionID,selectedRow) => {
    setIsModalVisible(true)
    setSelectedCollection(selectedRow)
    setSelectedCollectionID(collectionID)
    setSelectedTransactionID(transactionID)

    if(selectedRow.payment__mode == 'phonepe'){
      fetchPhonePeEntries(collectionID,transactionID)
    }

  }

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedCollection([])
    setSelectedCollectionID(null);
    setSelectedTransactionID('');
  };

  const getPhonePePayments = () =>{
    fetchPhonePeEntries(selectedCollection.id,selectedTransactionID)
  }

  const fetchPhonePeEntries = (collectionID,transactionID) => {
    setPhonePeLoader(true)

    getData(`/finance/get_phonepe_entries/?collection_id=${collectionID}&transaction_id=${transactionID}`)
    .then(response =>{
       setPhonePeEntries(response.matching_entries);
    })
    .catch(error => {
      console.log(error.message);
    })
    .finally(()=>{
      setPhonePeLoader(false)
    })
  }

  const highlightMatch = (text, highlight) => {
    if (!highlight) return text;

    const regex = new RegExp(`(${highlight})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "#ffeb3b", padding: "0 2px" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const highlightAmount = (value, selectedAmount) => {
    if (Number(value) === Number(selectedAmount))
      return (
        <span style={{ backgroundColor: "#ffeb3b", padding: "0 2px" }}>
          {value.toLocaleString("en-IN")}
        </span>
      );

    return value.toLocaleString("en-IN");
  };

  const highlightDate = (collectedDate, paidAt) => {
    if (!collectedDate || !paidAt) return collectedDate;

    const collectedDatePart = collectedDate.split(" ")[0];
    const paidAtDatePart = paidAt.split(" ")[0];

    if (collectedDatePart === paidAtDatePart) {
      return (
        <span>
          <span style={{ backgroundColor: "#ffeb3b", padding: "0 2px" }}>
            {collectedDatePart}
          </span>
          {" " + collectedDate.split(" ").slice(1).join(" ")}
        </span>
      );
    }

    return collectedDate;
  };

  const phonePeColumns=[
    {
      title: "Collected Date",
      dataIndex: "collected_date",
      render: (value) => highlightDate(value, selectedCollection.PaidDate),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (value) => highlightAmount(value, selectedCollection.Amount),
      align: "right",
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      render: (value) => highlightMatch(value, selectedTransactionID),
    },
    {
      title: "UTR",
      dataIndex: "transaction_utr",
      render: (value) => highlightMatch(value, selectedTransactionID),
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
    },
    {
      title: "",
      render: (_, record) => 
       record.is_processed ? (
        <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 18 }} />
      ) : (
        <Button
          size="small"
          type="default"
          style={{
            color: "#1890ff",
            borderColor: "#1890ff",
          }}
          onClick={() =>
            confirmPhonePeVerify(selectedCollection.id, record.id)
          }
        >
          Verify
        </Button>
      ),
    }
  ]

  const confirmPhonePeVerify = (collection_id, phonepe_id) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Do you want to continue verifying this PhonePe collection?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        verifyPhonepeCollection(collection_id, phonepe_id);
      },
    });
  };

  const verifyPhonepeCollection = (collection_id,phonepe_id) => {
    postData('/finance/verify_phonepe_payment/', {'collection_id': collection_id, 'transaction_id': selectedTransactionID, 'phonepe_id': phonepe_id })
    .then(response =>{
      handleModalClose()
      if(response.success){
        getUnverifiedCollections()
        Modal.success({
          content: response.message,
        });
      }
      else{
        Modal.error({
          content: response.message,
        });
      }
    })
    .catch(error => {
      console.log(error.message);
    });
  }


  const renderHeader = (title) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: 'bold',textWrap: 'nowrap' }}>{title}</div>
    )
  }  

  const renderCollectionCustomer = (data,isAmount) => {
    return(
      <div>
        <div>{isAmount ? formatIndianCurrency(data) : data}</div>
      </div>
    )
  }

  const getDateSorter = (dataIndex) => ({
    sorter: (a, b) => moment(a[dataIndex]).valueOf() - moment(b[dataIndex]).valueOf(),
  });

  const getAmountSorter = (dataIndex) => ({
    sorter: (a, b) => a[dataIndex] - b[dataIndex],
  });

  const sampleData = collectionData[0] || {};
  const excludedFields = ['id', 'StartDate', 'EndDate', 'Package', 'Status'];

	const columns = [
    ...Object.keys(sampleData).filter(key => !excludedFields.includes(key)).map((key) => ({
  	  title: renderHeader(toProperCase(key)),
  	  dataIndex: key,
  	  render: (value, record) => {
  	    const isAmount = key.toLowerCase().includes('amount');

        if (key === "Transaction_id") {
          return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6 }}>
              {value ? (
                <>
                  <span>{value}</span>
                  <EditOutlined
                    onClick={() => openActionModal(record?.id, value, record)}
                    style={{ fontSize: "14px", cursor: "pointer", color: "#1890ff" }}
                    title="Edit Transaction ID"
                  />
                </>
              ) : (
                <Button
                  size="small"
                  type="default"
                  onClick={() => openActionModal(record?.id, value, record)}
                  style={{
                    borderColor: "#1890ff",
                    color: "#1890ff",
                    fontSize: 12,
                    padding: "0px 8px",
                  }}
                >
                  + Add
                </Button>
              )}
            </div>
          );
        }

  	    return renderCollectionCustomer(value, isAmount);
  	  },
  	  align: 'center',
      ...((key === 'customer__name' || key === 'Mobile') ? getSearchFilter(key, toProperCase(key)) : {}),
      ...((key === 'Venue' || key === 'City' || key === 'Status' 
        || key === 'CollectedBy' || key === 'payment__mode') ? getDropdownFilter(key,collectionData) : {}),
      ...(key.includes('Date') ? getDateSorter(key) : {}),
      ...((key === 'Amount') ? getAmountSorter(key) : {})
  	  // width: 110,
  	})),
  ];

	return(
		<Spin spinning={loading} indicator={<Spinner />}>
			<Styled.MainContainer>
				<Styled.TopDiv>    
          <Breadcrumb style={{padding:'10px'}} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/collection">
                <BankFilled />
                <span style={{paddingLeft:'5px'}}>Collection</span>
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
            	<span>Unverified Collections</span>
            </Breadcrumb.Item>

          </Breadcrumb>

          <div style={{display: 'flex'}}>
            <Styled.Selector>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setMonth}
                  value = {month}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <div className = 'mainSelector'>
                <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
              </div> 
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        <Styled.NewHeader>   
          <span></span>     
          <span> Unverified Collections</span>
          {
             <>
              <ReactHTMLTableToExcel
                className="btn btn-sm downloadBtn"
                table="table-for-download"
                filename={'Unverified Collections '+ ' ' + moment(month, 'MM').format('MMMM') + ' ' + year}
                sheet={'Unverified Collections'}
                buttonText="Download"/>
             </>
          }
        </Styled.NewHeader>
        <div className="recordCount">{collectionData?.length || 0} records</div>
        <div>
        	<Table
            className="drill-down-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={collectionData}
            pagination={{pageSize: 50, showSizeChanger: false}}
            scroll={{ x: 'max-content' }}
          />
        </div>
			</Styled.MainContainer>
      <table style={{display: 'none'}} id="table-for-download">
        <thead>
          <tr>
            {Object.keys(sampleData).map((head, index) => (
              <th key={index}>{toProperCase(head)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {collectionData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.keys(sampleData).map((key, colIndex) => {
                const value = row[key];
                const isAmount = key.toLowerCase().includes('amount');
                return (
                  <td key={colIndex}>
                    {isAmount ? formatIndianCurrency(value) : value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      <Modal title={selectedTransactionID ? 'Edit Transaction ID' : 'Add Transaction ID'}
        open={isModalVisible} 
        closable={true} 
        width={selectedCollection.payment__mode == 'phonepe' ? 1000 : 520} 
        onCancel={handleModalClose}
        footer={
          selectedCollection.payment__mode == 'phonepe'
            ? null
            : [
                <Button key="back" onClick={handleModalClose}>
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={handleFormSubmit}
                  loading={isSaving}
                >
                  Submit
                </Button>,
              ]
        }
      >
        <p style={{fontSize: 13,color: "#595959",textAlign:'center'}}>
          {selectedCollection.customer__name && selectedCollection.customer__name + '- '}  {selectedCollection.Mobile} paid{" "}
          <span style={{ fontWeight: 600 }}>
            {selectedCollection.Amount?.toLocaleString("en-IN")}
          </span>{" "}
          at{" "}
          <span style={{ fontWeight: 600 }}>{selectedCollection.Venue}</span>{" "}
          on{" "}
          <span style={{ fontWeight: 600 }}>{selectedCollection.PaidDate}</span>
        </p>

        {selectedCollection.payment__mode != 'phonepe' ?
          <Input ref={inputRef} placeholder="enter transaction id" value={selectedTransactionID} onChange={(e)=>setSelectedTransactionID(e.target.value)} />
        :
        <>
          
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 20,
            }}
          >
            <div style={{ width: 150, fontWeight: 500 }}>Transaction ID</div>

            <div style={{ display: "flex", gap: 10, flex: 1 }}>
              <Input
                ref={inputRef}
                placeholder="Enter transaction ID"
                value={selectedTransactionID}
                onChange={(e) => setSelectedTransactionID(e.target.value)}
              />

              <Button
                type="default"
                loading={phonePeLoader}
                onClick={getPhonePePayments}
              >
                Search
              </Button>

              <Button type="primary" onClick={handleFormSubmit}>
                Save
              </Button>
            </div>
          </div>


          {phonePeLoader ?
            <p style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>
              Checking for matching PhonePe payments...
            </p>
          :
            phonePeEntries.length > 0 ? 
            <div style={{ maxWidth: "100%", overflowX: "auto" }}>
              <p style={{ fontSize: 14, fontWeight: 500, marginBottom: 10, color: "#389e0d" }}>
                Matching PhonePe payments found for this payment
              </p>
              
              <Table
                dataSource={phonePeEntries}
                columns={phonePeColumns}
                size="small"
                pagination={phonePeEntries.length > 5 ? { pageSize: 5 } : false}
                bordered
                rowKey="id"
              />
            </div>
          :
            
            <p style={{ fontSize: 13, fontWeight: 500, marginBottom: 10, color: "#cf1322" }}>
              No matching PhonePe payments found for this transaction ID
            </p>            
          }
          </>
        }


      </Modal>

      {/*{ selectedCollectionID &&
        <Modal
          title={selectedTransactionID ? 'Edit Transaction ID' : 'Add Transaction ID'}
          open={isModalVisible}
          onCancel={handleModalClose}
          onOk={handleFormSubmit}
          okText={isSaving ? 'Saving...' : 'Save'}
          okButtonProps={{ disabled: isSaving }}
          cancelButtonProps={{ disabled: isSaving }}
          confirmLoading={isSaving}
        >

          
          <Form form={form} layout="vertical">
            <Form.Item name="Transaction_ID" label="Transaction ID" rules={[{ required: true, message: 'Please enter transaction id' }]}>
              <Input placeholder="Enter transaction ID"/>
            </Form.Item>
          </Form>
        </Modal>
      }
*/}
		</Spin>
	)
}

export default UnverifiedCollections;	